// extracted by mini-css-extract-plugin
module.exports = {"title":"WhatsNextDisplay_title__1JFCU","icon":"WhatsNextDisplay_icon__2N-6U","whatsNext":"WhatsNextDisplay_whatsNext__15Fec"};